import { render, staticRenderFns } from "./CandidatesTab.vue?vue&type=template&id=51612e8d&scoped=true"
import script from "./CandidatesTab.vue?vue&type=script&lang=js"
export * from "./CandidatesTab.vue?vue&type=script&lang=js"
import style0 from "./CandidatesTab.vue?vue&type=style&index=0&id=51612e8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51612e8d",
  null
  
)

export default component.exports